var map = {
	"./abkhazia.webp": 837,
	"./afganistan.webp": 838,
	"./albania.webp": 839,
	"./algeria.webp": 840,
	"./american_samoa.webp": 841,
	"./andorra.webp": 842,
	"./angola.webp": 843,
	"./anguilla.webp": 844,
	"./antigua_and_barbuda.webp": 845,
	"./argentina.webp": 846,
	"./armenia.webp": 847,
	"./aruba.webp": 848,
	"./australia.webp": 849,
	"./austria.webp": 555,
	"./azad_kashmir.webp": 850,
	"./azerbaijan.webp": 851,
	"./bahamas.webp": 852,
	"./bahrain.webp": 853,
	"./bangladesh.webp": 854,
	"./barbados.webp": 855,
	"./belarus.webp": 856,
	"./belgium.webp": 857,
	"./belize.webp": 858,
	"./benin.webp": 859,
	"./bermuda.webp": 860,
	"./bhutan.webp": 861,
	"./bolivia.webp": 862,
	"./bosnia_and_herzegovina.webp": 863,
	"./botswana.webp": 864,
	"./brazil.webp": 865,
	"./brunei.webp": 866,
	"./bulgaria.webp": 867,
	"./burkina_faso.webp": 868,
	"./burundi.webp": 869,
	"./cambodia.webp": 870,
	"./cameroon.webp": 871,
	"./canada.webp": 872,
	"./cape_verde.webp": 873,
	"./cayman_islands.webp": 874,
	"./central_african_republic.webp": 875,
	"./chad.webp": 876,
	"./chile.webp": 877,
	"./china.webp": 878,
	"./colombia.webp": 879,
	"./comoros.webp": 880,
	"./congo.webp": 881,
	"./cook_island.webp": 882,
	"./costa_rica.webp": 883,
	"./croatia.webp": 884,
	"./cuba.webp": 885,
	"./cyprus.webp": 886,
	"./czech_republick.webp": 887,
	"./democratic_republic_of_the_congo.webp": 888,
	"./denmark.webp": 889,
	"./djibouti.webp": 890,
	"./dominica.webp": 891,
	"./dominican_republic.webp": 892,
	"./donetsk_people_s_republic.webp": 893,
	"./east_timor.webp": 894,
	"./ecuador.webp": 895,
	"./egypt.webp": 896,
	"./el_salvador.webp": 897,
	"./equatorial_guinea.webp": 898,
	"./eritrea.webp": 899,
	"./estonia.webp": 900,
	"./eswatini.webp": 901,
	"./ethiopia.webp": 902,
	"./falkland_islands.webp": 903,
	"./federated_states_of_micronesia.webp": 904,
	"./fiji.webp": 905,
	"./finland.webp": 906,
	"./france.webp": 907,
	"./french_guiana.webp": 908,
	"./gabon.webp": 909,
	"./gambia.webp": 910,
	"./georgia.webp": 911,
	"./germany.webp": 912,
	"./ghana.webp": 913,
	"./gibraltar.webp": 914,
	"./globe.webp": 556,
	"./greece.webp": 915,
	"./greenland.webp": 916,
	"./grenada.webp": 917,
	"./guadeloupe.webp": 918,
	"./guam.webp": 919,
	"./guatemala.webp": 920,
	"./guernsey.webp": 921,
	"./guinea.webp": 922,
	"./guinea_bissau.webp": 923,
	"./guyana.webp": 924,
	"./haiti.webp": 925,
	"./honduras.webp": 926,
	"./hong_kong.webp": 927,
	"./hungary.webp": 928,
	"./iceland.webp": 929,
	"./india.webp": 930,
	"./indonesia.webp": 931,
	"./iran.webp": 932,
	"./iraq.webp": 933,
	"./ireland.webp": 934,
	"./isle_of_man.webp": 935,
	"./israel.webp": 936,
	"./italy.webp": 937,
	"./ivory_coast.webp": 938,
	"./jamaica.webp": 939,
	"./japan.webp": 940,
	"./jersey.webp": 941,
	"./jordan.webp": 942,
	"./kazakhstan.webp": 943,
	"./kenya.webp": 944,
	"./kirgyzstan.webp": 945,
	"./kiribati.webp": 946,
	"./kosovo.webp": 947,
	"./kuwait.webp": 948,
	"./laos.webp": 949,
	"./latvia.webp": 950,
	"./lebanon.webp": 951,
	"./lesotho.webp": 952,
	"./liberia.webp": 953,
	"./libyan_arab_jamahiriya.webp": 954,
	"./liechtenstein.webp": 955,
	"./lihansk_people_s_republic.webp": 956,
	"./lithuania.webp": 957,
	"./luxembourg.webp": 958,
	"./macao.webp": 959,
	"./macedonia.webp": 960,
	"./madagascar.webp": 961,
	"./malawi.webp": 962,
	"./malaysia.webp": 963,
	"./maldives.webp": 964,
	"./mali.webp": 965,
	"./malta.webp": 966,
	"./marshall_islands.webp": 967,
	"./martinique.webp": 968,
	"./mauritania.webp": 969,
	"./mauritius.webp": 970,
	"./mayotte.webp": 971,
	"./mexico.webp": 972,
	"./moldova.webp": 973,
	"./monaco.webp": 974,
	"./mongolia.webp": 975,
	"./montenegro.webp": 976,
	"./montserrat.webp": 977,
	"./morocco.webp": 978,
	"./mozambique.webp": 979,
	"./myanmar.webp": 980,
	"./namibia.webp": 981,
	"./nauru.webp": 982,
	"./nepal.webp": 983,
	"./netherlands.webp": 984,
	"./new_caledonia.webp": 985,
	"./new_zealand.webp": 986,
	"./nicaragua.webp": 987,
	"./niger.webp": 988,
	"./nigeria.webp": 989,
	"./niue.webp": 990,
	"./norfolk_island.webp": 991,
	"./north_korea.webp": 992,
	"./norway.webp": 993,
	"./notrhen_cyprus.webp": 994,
	"./oman.webp": 995,
	"./pakistan.webp": 996,
	"./palau.webp": 997,
	"./panama.webp": 998,
	"./papua_new_guinea.webp": 999,
	"./paraguay.webp": 1000,
	"./peru.webp": 1001,
	"./philippines.webp": 1002,
	"./poland.webp": 1003,
	"./portugal.webp": 1004,
	"./pridnestrovian_moldovian_republic.webp": 1005,
	"./puerto_rico.webp": 1006,
	"./qatar.webp": 1007,
	"./republick_of_artsakh.webp": 1008,
	"./romania.webp": 1009,
	"./russia.webp": 1010,
	"./rwanda.webp": 1011,
	"./saint_barthelemy.webp": 1012,
	"./saint_kitts_and_nevis.webp": 1013,
	"./saint_lucia.webp": 1014,
	"./saint_martin.webp": 1015,
	"./saint_vincent_and_the_grenadines.webp": 1016,
	"./samoa.webp": 1017,
	"./san_marino.webp": 1018,
	"./sao_tome_and_principe.webp": 1019,
	"./saudi_arabia.webp": 1020,
	"./senegal.webp": 1021,
	"./serbia.webp": 1022,
	"./seychelles.webp": 1023,
	"./sierra_leone.webp": 1024,
	"./singapore.webp": 1025,
	"./slovakia.webp": 1026,
	"./slovenia.webp": 1027,
	"./solomon_islands.webp": 1028,
	"./somalia.webp": 1029,
	"./somaliland.webp": 1030,
	"./south_africa.webp": 1031,
	"./south_korea.webp": 1032,
	"./south_ossetia.webp": 1033,
	"./south_sudan.webp": 1034,
	"./spain.webp": 1035,
	"./sri_lanka.webp": 1036,
	"./state_of_palestine.webp": 1037,
	"./sudan.webp": 1038,
	"./suriname.webp": 1039,
	"./sweden.webp": 1040,
	"./switzerland.webp": 1041,
	"./syrian_arab_republic.webp": 1042,
	"./taiwan.webp": 1043,
	"./tajikistan.webp": 1044,
	"./tanisia.webp": 1045,
	"./tanzania.webp": 1046,
	"./thailand.webp": 1047,
	"./togo.webp": 1048,
	"./tonga.webp": 1049,
	"./trinidad_and_tobago.webp": 1050,
	"./tunisia.webp": 1051,
	"./turkey.webp": 1052,
	"./turkmenistan.webp": 1053,
	"./tuvalu.webp": 1054,
	"./uganda.webp": 1055,
	"./ukraine.webp": 1056,
	"./united_arab_emirates.webp": 557,
	"./united_kingdom.webp": 1057,
	"./uruguay.webp": 1058,
	"./usa.webp": 558,
	"./uzbekistan.webp": 1059,
	"./vanuatu.webp": 1060,
	"./vatican.webp": 1061,
	"./venezuela.webp": 1062,
	"./vietnam.webp": 1063,
	"./virgin_islands_br.webp": 1064,
	"./virgin_islands_us.webp": 1065,
	"./wallis_and_futuna.webp": 1066,
	"./western_sahara.webp": 1067,
	"./yemen.webp": 1068,
	"./zaire.webp": 1069,
	"./zambia.webp": 1070,
	"./zimbabwe.webp": 1071
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 288;